export default "__VITE_ASSET__DJfqSh$v__"